module.exports = __webpack_public_path__ + "img/excel-300.7188a385.png";